import { ColumnDef } from '@tanstack/react-table'
import { useTranslation } from 'react-i18next'

import { LastModifiedCell } from 'components/Table'
import { COLUMN_SIZE } from 'components/Table/constants'
import { DomainAlerts } from 'features/inventory/domain'
import ActionsCell from './components/ActionsCell'
import { TriggerCell } from './components/TriggerCell'
import { PageForTable } from './types'

export const useColumns = (): ColumnDef<PageForTable>[] => {
  const { t } = useTranslation('features/page')

  return [
    {
      accessorKey: 'domain.name',
      header: t('list.header.domainName'),
      meta: { whiteSpacePre: true },
    },
    {
      accessorKey: 'name',
      header: t('list.header.pageName'),
      meta: { whiteSpacePre: true },
    },
    {
      accessorKey: 'triggers',
      cell: ({ row: { original } }) => <TriggerCell page={original} />,
      header: t('list.header.triggers'),
      meta: {
        nonClickable: true,
      },
    },
    {
      accessorKey: 'alerts',
      cell: ({
        row: {
          original: {
            domain: { alerts },
          },
        },
      }) => <DomainAlerts alerts={alerts} />,
      header: t('list.header.alerts'),
      meta: { nonClickable: true },
    },
    {
      accessorKey: 'updatedAt',
      cell: props => <LastModifiedCell {...props} />,
      header: t('list.header.lastModified'),
    },
    {
      cell: ({ row }) => <ActionsCell {...row.original} />,
      header: t('list.header.actions'),
      id: 'actions',
      meta: {
        centered: true,
        nonClickable: true,
      },
      size: COLUMN_SIZE.SM,
    },
  ]
}
